import { gaodingEditHost, huabanArtHost } from "@/utils/host";
import { useEffect, useState } from "react";

/**
 * 获取AI工具的完整URL
 * AB实验组 AI_Redirect_path 为 string_2 时，跳转到 gaoding.art
 * @param shouldFetch 是否需要获取URL，用于性能优化
 * @returns
 */
export function useAiToolUrl(shouldFetch: boolean = true) {
  const [aiToolUrl, setAiToolUrl] = useState<string>(
    `https://${gaodingEditHost}/create-design`
  );
  const [loading, setLoading] = useState<boolean>(shouldFetch);

  useEffect(() => {
    if (!shouldFetch) {
      setLoading(false);
      return;
    }

    const fetchUrl = async () => {
      try {
        setLoading(true);
        setAiToolUrl(`https://${huabanArtHost}/create`);
      } catch (err) {
        console.warn("获取动态 AI工具URL 失败，使用默认配置:", err);
        setAiToolUrl(`https://${huabanArtHost}/create-design`); // 兜底使用静态配置
      } finally {
        setLoading(false);
      }
    };

    fetchUrl();
  }, [shouldFetch]);

  return { aiToolUrl, loading };
}
